import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/sections/Home'
import List from '@/sections/List'
import Viewer from '@/sections/Viewer'
import About from '@/sections/About'
import analytics from '@/core/analytics'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/list',
			name: 'list',
			component: List
		},
		{
			path: '/viewer/:category/:id?',
			name: 'viewer',
			component: Viewer
		},
		{
			path: '/about',
			name: 'about',
			component: About
		}
	]
})

router.afterEach((to, from, next) => {
	analytics.pageview(to)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js